/* ==========================================================================
   iTechVista — related products
   --------------------------------------------------------------------------
   Companion to sections/itv-related-products.liquid.

   The section renders its collection fallback server-side, so the slot is
   already filled — and works with JS disabled — before this file runs. All
   this does is ask the Section Rendering API whether Shopify actually has
   recommendations for the product, and swap them in ONLY when it does.

   The response is checked for data-itv-rp-source="recommendations" first: a
   response that came back with a fallback, an error page, or nothing at all
   is discarded rather than replacing perfectly good server-rendered markup.

   Two entry points, because Dawn's global.js may already own the
   <product-recommendations> tag name and a tag can only be defined once:

     1. tag name free  -> define the custom element normally.
     2. tag name taken -> adopt our own [data-itv-rp] instances, cancelling
                          the incumbent's observer first so it cannot fetch a
                          differently-shaped URL over the top of us.

   Deferred scripts execute in document order, so this runs immediately after
   global.js and before any IntersectionObserver callback can fire.
   ========================================================================== */
(function () {
  'use strict';

  var ROOT_MARGIN = '0px 0px 400px 0px';

  function swap(element, text) {
    var incoming = new DOMParser().parseFromString(text, 'text/html').querySelector('product-recommendations');

    if (!incoming) return;
    // Only real recommendations may replace what is already on screen.
    if (!incoming.querySelector('[data-itv-rp-source="recommendations"]')) return;

    element.innerHTML = incoming.innerHTML;
  }

  function load(element) {
    if (element.itvRpLoaded) return;
    element.itvRpLoaded = true;

    var url = element.dataset.url;
    if (!url) return;

    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Recommendations request failed: ' + response.status);
        return response.text();
      })
      .then(function (text) {
        swap(element, text);
      })
      .catch(function (error) {
        // The server-rendered fallback stays exactly as it is.
        console.warn('[itv-related-products]', error);
      });
  }

  function watch(element) {
    if (element.itvRpWatched) return;
    element.itvRpWatched = true;

    if (typeof IntersectionObserver === 'undefined') {
      load(element);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          observer.disconnect();
          load(element);
          return;
        }
      },
      { rootMargin: ROOT_MARGIN }
    );

    element.itvRpObserver = observer;
    observer.observe(element);
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define(
      'product-recommendations',
      class ITVProductRecommendations extends HTMLElement {
        connectedCallback() {
          watch(this);
        }

        disconnectedCallback() {
          if (this.itvRpObserver) {
            this.itvRpObserver.disconnect();
            this.itvRpObserver = null;
          }
        }
      }
    );
    return;
  }

  // Tag name already taken: take our own instances back off the incumbent.
  var adopt = function () {
    var elements = document.querySelectorAll('product-recommendations[data-itv-rp]');

    for (var i = 0; i < elements.length; i++) {
      var element = elements[i];

      if (element.observer && typeof element.observer.disconnect === 'function') {
        element.observer.disconnect();
        element.observer = null;
      }

      watch(element);
    }
  };

  adopt();
  document.addEventListener('shopify:section:load', adopt);
})();
